import { Card, Typography, Grid, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Link } from '@mui/material';
import formatMoney from 'src/utils/formatMoney';

const GROUPS = [
  { key: 'by_practice', title: 'By Practice', groupBy: 'practice' },
  { key: 'by_offering', title: 'By Offering', groupBy: 'offering' },
  { key: 'by_segment', title: 'By Segment', groupBy: 'segment' },
  { key: 'by_business_type', title: 'By Business Type', groupBy: 'business_type' },
  { key: 'by_country', title: 'By Country', groupBy: 'country' },
  { key: 'by_partner', title: 'By Partner', groupBy: 'partner' },
];

// Value/count by every dimension. Count click drills without currency (count reconciles);
// TCV click drills with currency (TCV sum reconciles). group_value 'null' = Unassigned bucket.
export default function SegmentationSection({ segmentation, currencyId, currencyLabel, openDrill }) {
  if (!segmentation) return null;

  const drill = (groupBy, row, withCurrency) => {
    const groupValue = row.id === null || row.id === undefined ? 'null' : row.id;
    const params = { group_by: groupBy, group_value: groupValue, lifecycle: 'open' };
    if (withCurrency) params.currency_id = currencyId;
    openDrill(params, `${row.label}`);
  };

  return (
    <Card sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" fontWeight={600} mb={2}>Segmentation</Typography>
      <Grid container spacing={2}>
        {GROUPS.map((g) => {
          const rows = segmentation[g.key] || [];
          return (
            <Grid item xs={12} md={6} key={g.key}>
              <Typography variant="subtitle2" fontWeight={600} mb={0.5}>{g.title}</Typography>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell align="right">Count</TableCell>
                      <TableCell align="right">TCV</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, idx) => (
                      <TableRow key={`${g.key}-${row.id ?? 'null'}-${idx}`} hover>
                        <TableCell>{row.label}</TableCell>
                        <TableCell align="right">
                          <Link component="button" underline="hover" onClick={() => drill(g.groupBy, row, false)}>
                            {row.count}
                          </Link>
                        </TableCell>
                        <TableCell align="right">
                          <Link component="button" underline="hover" onClick={() => drill(g.groupBy, row, true)}>
                            {formatMoney(row.tcv, currencyLabel)}
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                    {rows.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={3} align="center" sx={{ color: 'text.secondary', py: 2 }}>
                          No data.
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          );
        })}
      </Grid>
    </Card>
  );
}
